// local dev, PR preview, or QA env
export const isDevOrQA = /localhost|dev-backend.turn.systems|pr.*.my.preview.run|qa.whatsapp.turn.io/.test(
  window.location.host
);

// local dev or PR preview env (not QA)
export const isDevOrPR = /localhost|dev-backend.turn.systems|pr.*.my.preview.run/.test(window.location.host);
